import type { IconData } from '@stacksjs/iconify-core'

export const pinAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 9.9A5.002 5.002 0 0 1 5 0a5 5 0 0 1 1 9.9V19a1 1 0 0 1-2 0zM5 8a3 3 0 1 0 0-6a3 3 0 0 0 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pinAlt
